import React from 'react'
import PropTypes from 'prop-types'
import { LazyLoadComponent } from 'react-lazy-load-image-component'
import Avatar from '@material-ui/core/Avatar'

const LazyAvatar = ({ src, alt, style, scrollPosition, testId, containerStyle }) => {
  const firstLetter = typeof alt === 'string' ? `${alt?.split(' ')[0]?.[0]?.toUpperCase()}` : ''

  return (
    <div
      className="jisr-lazy-avatar"
      style={containerStyle}
    >
      <LazyLoadComponent scrollPosition={scrollPosition}>
        <Avatar
          data-testid={testId}
          className="jisr-lazy-avatar-img"
          style={style}
          src={src}
          alt={alt}
        >
          {firstLetter}
        </Avatar>
      </LazyLoadComponent>
    </div>
  )
}

LazyAvatar.propTypes = {
  testId: PropTypes.string,
  src: PropTypes.string,
  alt: PropTypes.string,
  style: PropTypes.shape(),
  containerStyle: PropTypes.shape(),
  scrollPosition: PropTypes.shape(),
}

export default LazyAvatar
